<template>
  <el-container>
    <main class="tab__container">
      <h2 class="page__title">Юридическое лицо: {{ org.org_name }}</h2>
      <el-tabs ref="tabs">
        <el-tab-pane v-for="(tab, i) in components" :label="tab.name" :key="i">
          <component
            v-loading="loading && tab.name === 'Информация'"
            v-bind="tab.props"
            :is="tab.component"
            :org-id="id"
          />
        </el-tab-pane>
      </el-tabs>
    </main>
  </el-container>
</template>

<script>
import { checkPermission } from "@/core/helpers/permissions";
import { mapActions, mapState } from "vuex";
import OrgEditTab from "@/components/Org/components/tabs/OrgEditTab";

export default {
  name: "Org",
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    const tabs = [
      {
        name: "Информация",
        component: OrgEditTab,
        permission: "orgs:read",
        subject: "info",
      },

    ];
    return {
      loading: false,
      components: tabs.filter(({ permission }) => checkPermission(permission)),
    };
  },
  computed: {
    ...mapState("org", ["org"]),
  },
  watch: {
    id: {
      immediate: true,
      handler(id, prevId) {
        this.loadOrg();
        if (prevId) this.$refs.tabs.setCurrentName("0");
      },
    },
  },
  methods: {
    ...mapActions("org", {
      getOrg: "GET_ORG",
    }),
    loadOrg() {
      this.loading = true;
      this.getOrg(this.id).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
